import { gql } from '@apollo/client'

export const GIFT_CARD_BALANCE = gql`
    query GiftCardBalance($GiftCardBalanceInput: GiftCardBalanceInput!) {
        GiftCardBalance(giftCard: $GiftCardBalanceInput) {
            success
            message
            cardData {
                value_balance
                value_amount
            }
        }
    }
`

export type GiftCardBalanceQueryVariables = {
    GiftCardBalanceInput: {
        cardNumber: string
        cardPin: string
    }
}

export type GiftCardBalanceQuery = {
    GiftCardBalance: {
        success: boolean
        message: string
        cardData: {
            value_balance: number
            value_amount: number
        } | null
    }
}
